import React from 'react'
import Page from '../Page'

export default class LegalCookiePolicy extends Page
{
    static path = '/legal/cookie-policy';

    constructor(props)
    {
		super(props);

		this.state = {
			...this.state,
			//
		};
	}

	componentDidMount()
	{
		super.componentDidMount();
	}

	render()
	{

		return (
			<div className="px-2 py-6 sm:px-6">
				<div className="w-full m-auto text-center p-2 sm:p-6 md:w-2/3">
					<h2 className="text-3xl mb-2">{TB.trans('legal.cookie_policy.title')}</h2>

					<div
						className="text-base"
						dangerouslySetInnerHTML={{
							__html: TB.trans('legal.cookie_policy.content')
						}}
					/>
				</div>
			</div>
		);
	}
}
